"use client";

import { AnimatePresence } from "framer-motion";
import Toast from "./toast";
import { useToast } from "../../hooks/useToast";

const ToastContainer: React.FC = () => {
	const { toasts } = useToast();

	return (
		<div className="fixed top-24 left-5 z-50 flex flex-col space-y-2">
			<AnimatePresence>
				{toasts.map((toast) => (
					<Toast key={toast.id} message={toast.message} type={toast.type} />
				))}
			</AnimatePresence>
		</div>
	);
};

export default ToastContainer;
